/**
 * Created by baladewa on 10/27/16.
 */
'use strict';
(function () {
    angular
        .module('commons')
        .component('searchComponent', {
            templateUrl: function($attrs){
                return $attrs.template;
            },
            controller: function ($scope,$timeout) {
                var vm = this;
                vm.searchCriteria = {};
                vm.masterLists = {};
                vm.total = false;

                vm.submitSearchAny = function () {
                    submitForm();
                };

                vm.changeAny = function (event, flag,searchCriteria,otherValues) {
                    var options = {
                        event: event,
                        flag: flag,
                        searchParams: vm.searchCriteria,
                        otherValues : otherValues
                    };
                    vm.onChangeCriteria(options);
                    vm.onChangeField(options);
                };

                vm.setDefaultValue = function (key) {
                  vm.searchCriteria[key] = ' ';
                };

                function submitForm() {
                    if(vm.searchAny.$valid){
                        var options = {
                            searchParams: vm.searchCriteria
                        };
                        vm.onSearch(options);
                    }
                }

                vm.$onChanges = function (changeObj) {
                    if(changeObj.searchRequestModel && changeObj.searchRequestModel &&
                        (changeObj.searchRequestModel.currentValue !== changeObj.searchRequestModel.previousValue)){
                        $timeout(function () {
                            vm.searchCriteria = changeObj.searchRequestModel.currentValue;
                        },0)
                    }

                    if(changeObj.masterDataLists && changeObj.masterDataLists &&
                        (changeObj.masterDataLists.currentValue !== changeObj.masterDataLists.previousValue)){
                        $timeout(function () {
                            vm.masterLists = changeObj.masterDataLists.currentValue;
                        },0)
                    }
                };
            },
            bindings: {
                masterDataLists: '<',
                onSearch: '&',
                onChangeCriteria: '&',
                searchRequestModel: '<',
                onChangeField: '&',
                searchPanelToggle: '='
            }
        });
})();
